function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnvelope = function SvgEnvelope(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-346,-133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "matrix(1.61997,0,0,1.61997,231.838,117.77)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0772164,0,0,0.0772164,70.2088,8.72201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.949,372.155C31.949,392.233 48.213,408.495 68.289,408.495L431.71,408.495C451.788,408.495 468.05,392.233 468.05,372.155L468.05,126.845C468.05,106.766 451.788,90.505 431.71,90.505L68.29,90.505C48.213,90.505 31.95,106.766 31.95,126.845L31.95,372.155L31.949,372.155ZM165.684,249.775L82.549,166.097C75.654,159.191 75.654,148.014 82.549,141.112C89.461,134.205 100.639,134.205 107.533,141.112L240.187,273.934C245.545,279.204 254.363,279.204 259.636,273.934L392.457,141.112C399.357,134.205 410.538,134.205 417.442,141.112C424.346,148.014 424.346,159.191 417.442,166.097L334.218,249.775L417.442,332.902C424.346,339.802 424.346,350.982 417.442,357.886C410.538,364.786 399.357,364.786 392.457,357.886L309.322,274.847C309.322,274.847 283.343,301.287 278.622,306.011C271.259,313.186 261.079,317.641 249.999,317.641C238.731,317.641 228.554,313.098 221.199,305.735C216.38,301.013 190.58,274.847 190.58,274.847L107.533,357.886C100.638,364.786 89.461,364.786 82.549,357.886C75.654,350.982 75.654,339.802 82.549,332.902L165.684,249.775Z",
    style: {
      fill: "nonzero"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnvelope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/envelope.21806ee0.svg";
export { ForwardRef as ReactComponent };